import { Controller } from "@hotwired/stimulus"

// Wizard signup: submit guard (e.g. CGU) + double-submit protection
export default class extends Controller {
  static targets = ["submitBtn", "submitBtnText", "submitBtnSpinner", "termsCheckbox", "termsError", "termsWrapper"]

  connect() {
    this._onSubmit = this._onSubmit.bind(this)
    this.element.addEventListener("submit", this._onSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this._onSubmit)
  }

  _onSubmit(event) {
    if (!this._clientValidationPass()) {
      event.preventDefault()
      return
    }
    this._lockSubmit()
  }

  clearClientTermsError() {
    if (!this.hasTermsCheckboxTarget || !this.termsCheckboxTarget.checked) {
      return
    }

    this._hideClientTermsError()
  }

  _currentStep() {
    const input = this.element.querySelector("[name='user[current_step]']")
    return input ? input.value : null
  }

  _clientValidationPass() {
    if (this._currentStep() !== "picture") {
      return true
    }
    if (!this.hasTermsCheckboxTarget) {
      return true
    }

    if (!this.termsCheckboxTarget.checked) {
      this._showClientTermsError()
      return false
    }

    this._hideClientTermsError()
    return true
  }

  _showClientTermsError() {
    if (!this.hasTermsErrorTarget) {
      return
    }

    const text = this.termsErrorTarget.dataset.message || ""
    this.termsErrorTarget.textContent = text
    this.termsErrorTarget.classList.remove("hidden")
    this.termsErrorTarget.classList.add("mt-2")

    if (this.hasTermsWrapperTarget) {
      this.termsWrapperTarget.classList.add("ring-2", "ring-red-500", "rounded-md", "p-2", "-m-0.5")
    }
  }

  _hideClientTermsError() {
    if (!this.hasTermsErrorTarget) {
      return
    }

    this.termsErrorTarget.textContent = ""
    this.termsErrorTarget.classList.add("hidden")
    this.termsErrorTarget.classList.remove("mt-2")

    if (this.hasTermsWrapperTarget) {
      this.termsWrapperTarget.classList.remove("ring-2", "ring-red-500", "rounded-md", "p-2", "-m-0.5")
    }
  }

  _lockSubmit() {
    if (!this.hasSubmitBtnTarget) {
      return
    }

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.setAttribute("aria-busy", "true")
    this.submitBtnTarget.classList.add("opacity-70", "cursor-not-allowed")

    if (this.hasSubmitBtnTextTarget) {
      this.submitBtnTextTarget.classList.add("hidden")
    }
    if (this.hasSubmitBtnSpinnerTarget) {
      this.submitBtnSpinnerTarget.classList.remove("hidden")
    }
  }
}
